app.factory('areaFactory', ['$http', 'errorService', function ($http, errorService) {

    var _apiName = 'Area';

    var _list = function (search, options) {
        var dto = options.data;
        dto.search = search;
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/List', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _addNew = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/AddNew');
    };

    var _findRecord = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindRecord', dto);
    };

    var _save = function (isNew, dto) {
        var method = isNew ? 'Insert' : 'Update';
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/' + method, dto);
    };

    var _delete = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Remove', dto);
    };

    var _listAll = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListAll');
    };

    var factory = {};

    factory.addNew = _addNew;
    factory.findRecord = _findRecord;
    factory.list = _list;
    factory.save = _save;
    factory.delete = _delete;
    factory.listAll = _listAll;

    return factory;

}]);
